export default __webpack_public_path__ + "static/media/XK.fbf585aa.svg";